import { render, staticRenderFns } from "./stockInOrderCreate.vue?vue&type=template&id=1442e206&scoped=true&"
import script from "./stockInOrderCreate.vue?vue&type=script&lang=js&"
export * from "./stockInOrderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442e206",
  null
  
)

export default component.exports